import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
//
import StartPack from './pages/StartPack';
import NumberDiscovery from './pages/NumberDiscovery';
import IccId from './pages/IccId';
import Dealer from './pages/Dealer';
import DealerArchive from './pages/DealerArchive';
import Login from './pages/Login';
import Register from './pages/Register';
import History from './pages/History';
import Hierarchy from './pages/Hierarchy';
import TransferOwnership from './pages/TransferOwnership';

import { constants as authConstants } from './store/domains/auth';
import SelectProvider from './sections/auth/SelectProvider';
import IccidHistory from './pages/IccidHistory';
import IccidOrganization from './pages/IccidOrganization';
import AccessManagement from './pages/AccessManagement';
import DealersPage from './pages/DealersPage';
import SoPoMapping from './pages/SoPoMapping';
import SimSwap from './pages/SimSwap';
import Whitelist from './pages/Whitelist';

// ----------------------------------------------------------------------

export default function Router() {
  const userDetails = localStorage.getItem(authConstants.ACCESS_TOKEN);

  return useRoutes([
    {
      path: '/dashboard',
      element: userDetails ? <DashboardLayout /> : <Navigate to="/login" />,
      children: [
        { path: 'start-pack', element: <StartPack /> },
        { path: 'dealer-management', element: <DealersPage /> },
        { path: 'so-mapping', element: <SoPoMapping /> },
        { path: 'sim-swap', element: <SimSwap /> },
        { path: 'whitelist', element: <Whitelist /> },
        { path: 'access-management', element: <AccessManagement /> },
        { path: 'iccid-history', element: <IccidHistory /> },
        { path: 'number-discovery', element: <NumberDiscovery /> },
        { path: 'iccid', element: <IccId /> },
        { path: 'iccid-organization', element: <IccidOrganization /> },
        { path: 'hierarchy', element: <Hierarchy /> },
        { path: 'dealer', element: <Dealer /> },
        { path: 'transfer-ownership', element: <TransferOwnership /> },
        { path: 'dealer-archive', element: <DealerArchive /> },
        { path: 'history', element: <History /> },
      ],
    },
    {
      path: 'login',
      element: <Login />,
    },
    {
      path: 'provider',
      element: <SelectProvider />,
    },
    {
      path: 'otp',
      element: <Register />,
    },
    {
      path: '*',
      element: <Navigate to="/login" replace />,
    },
  ]);
}
